import styles from './ReportActionBar.module.scss';

export default function ReportActionBar() {
  return (
    <div className={styles.actionBar}>
      <div className={styles.inner}>
        <button
          type="button"
          className="interact-button button--outline button--small"
          onClick={() => window.print()}
        >
          <span className="button__content">
            <span className="button__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  x="6"
                  y="14"
                  width="12"
                  height="8"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Print or Save PDF
          </span>
        </button>
      </div>
    </div>
  );
}
